<template lang="pug">
  #navbar
    .container-fluid
      .row.home-nav.d-flex.px-0
        .col-md-3.col-sm-6.pr-2.pl-0
          a(href="https://datacivica.org/" target="_blank")
            img.logo(src="/assets/img/microsite/DC_white.png" alt="Data Cívica logo")
        .col-sm-6.social.pl-5.mobile
          a(href="https://twitter.com/datacivica" target="_blank")
            i.fab.fa-twitter
          a(href="https://www.facebook.com/datacivica/" target="_blank")
            i.fab.fa-facebook
          a(href="https://www.instagram.com/datacivica/" target="_blank")
            i.fab.fa-instagram
        .col-md-6.menu-items.uppercase.desktop.my-2
          a.px-1(
            v-for="(item, index) in menu"
            :href="'#' + item.slug"
          ) {{item.text}}
        .col-md-3.col-sm-6.social.pl-5.pr-0.desktop
          a.px-1(href="https://twitter.com/datacivica" target="_blank")
            i.fab.fa-twitter
          a.px-1(href="https://www.facebook.com/datacivica/" target="_blank")
            i.fab.fa-facebook
          a.px-1(href="https://www.instagram.com/datacivica/" target="_blank")
            i.fab.fa-instagram
      .row.home-nav.d-flex.px-0
        .col-md-12.pb-0.pt-4.menu-items.uppercase.mobile
          a(
            v-for="(item, index) in menu"
            :href="'#' + item.slug"
          ) {{item.text}}

    //router-link(to="/") Home
</template>

<script>
export default {
  name: "Navbar",
  data: function() {
    return {
      menu: [
        {
          text: "La amenaza",
          slug: "inicio-amenaza"
        },
        {
          text: "La respuesta",
          slug: "inicio-respuesta"
        },
        {
          text: "Las consecuencias",
          slug: "inicio-consecuencias"
        },
        {
          text: "Videos",
          slug: "videos"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
#navbar {
  min-height: 10vh;
  padding: 2rem;
  .home-nav {
    text-align: center;
    justify-content: center;
    align-items: center;
    .desktop {
      display: flex;
    }
    .logo {
      width: 80%;
      max-width: 260px;
    }
    .menu-items {
      justify-content: space-around;
      a {
        color: #fff;
      }
      a:hover {
        color: #ff6561;
        //background-color: #fff;
        text-decoration: none;
      }
    }
    .social {
      justify-content: space-around;
      i {
        color: #fff;
        font-size: 1.5rem;
      }
      i:hover {
        color: #ff6561;
        //background-color: #fff;
      }
    }
  }
}
@media (max-width: 500px) {
  #navbar {
    padding: 5vh 0;
    .home-nav {
      flex-wrap: nowrap;
      .desktop {
        display: none;
      }
      .mobile {
        display: flex;
      }
      .logo {
        width: 90%;
      }
      .social {
        i {
          font-size: 1rem;
        }
      }
      .menu-items {
        font-size: 0.8rem;
      }
    }
  }
}
</style>
